import api from './api';

const userProfileService = {
  getUserProfile: async () => {
    try {
      const response = await api.get('/api/user/profile/');
      return response.data;
    } catch (error) {
      console.error('Error fetching user profile:', error);
      throw error;
    }
  },

  updateUserProfile: async (profileData) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('No authentication token found');
      }

      // Ensure data is in the correct format
      const formattedData = {
        profile: {
          first_name: profileData.first_name,
          last_name: profileData.last_name,
          country: profileData.country,
          cell_phone_number: profileData.cell_phone_number,
          phone_number: profileData.phone_number,
          institution_name: profileData.institution_name,
          timezone: profileData.timezone,
          gmt_offset: profileData.gmt_offset
        }
      };

      const response = await api.put('/api/user/profile/', formattedData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
  },
  getUIPreferences: async () => {
    try {
      const response = await api.get('/api/user/profile/');
      return response.data?.profile?.ui_preferences || {};
    } catch (error) {
      console.warn('Failed to load UI preferences from server:', error);
      return {};
    }
  },

  updateUIPreferences: async (preferences) => {
    try {
      const response = await api.put('/api/user/profile/', {
        profile: { ui_preferences: preferences }
      });
      return response.data?.profile?.ui_preferences;
    } catch (error) {
      console.warn('Failed to save UI preferences to server:', error);
      throw error;
    }
  }
};

export default userProfileService;